export default "__VITE_PUBLIC_ASSET__29bdcc7d__"